<div *finLet="progress$ | async as progress" class="progress-circle" [ngClass]="color">
  <svg
    [attr.width]="size"
    [attr.height]="size"
    [attr.viewBox]="viewBox"
    role="progressbar"
    aria-valuemin="0"
    aria-valuemax="100"
    [attr.aria-valuenow]="progress"
    [attr.aria-label]="ariaLabel"
  >
    <circle
      class="path"
      [attr.r]="radius"
      [attr.cx]="position"
      [attr.cy]="position"
      fill="transparent"
      [attr.stroke-dasharray]="strokeDasharray"
      [ngStyle]="{ 'stroke-width': PATH_WIDTH + 'px' }"
    ></circle>
    <circle
      #bar
      class="bar"
      [attr.r]="radius"
      [attr.cx]="position"
      [attr.cy]="position"
      fill="transparent"
      [attr.stroke-dasharray]="strokeDasharray"
      [ngStyle]="{ 'stroke-width': BAR_WIDTH + 'px', 'stroke-dashoffset': (stroke$ | async) + 'px' }"
    ></circle>
  </svg>
</div>
<div class="content hide-empty absolute">
  <div class="grow flex flex--center align-center">
    <ng-content></ng-content>
  </div>
</div>
